import React from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "../../Error404";

import TrackingList from "./tracking-list";
import TrackingDetail from "./tracking-detail";

export default ({ match }) => {
  return (
    <Switch>
      <Route exact path={match.path} children={<TrackingList />} />
      <Route
        exact
        path={`${match.path}/:bill_no`}
        children={<TrackingDetail />}
      />
      <Route component={Error404} />
    </Switch>
  );
};
